function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
 * @description 封装游客服务
 * @example getGuestUser()
 */
import { getUserDeviceId } from '@gaoding/user-device-id';
import request from './request';
import { getConfig } from './config';

var GuestUser = /*#__PURE__*/function () {
  function GuestUser() {
    _classCallCheck(this, GuestUser);
  }

  _createClass(GuestUser, [{
    key: "guestfinger",
    get: function get() {
      return getUserDeviceId();
    }
  }, {
    key: "login",
    value: function login() {
      return request.post(getConfig('gaodingURL') + '/api/sessions', {
        guest_finger: this.guestfinger
      }).then(function (response) {
        return response.data;
      });
    } // 第三放合作伙伴接入

  }, {
    key: "partnerLogin",
    value: function partnerLogin(config) {
      return request.post(getConfig('gaodingURL') + '/api/sessions/partner', config).then(function (response) {
        return response.data;
      });
    }
  }]);

  return GuestUser;
}();

export default new GuestUser();